import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
const PopoverTitle = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { componentClass: Component = 'div', className, children, ...rest } = props;
    return /*#__PURE__*/ _jsx(Component, {
        ref: ref,
        ...rest,
        className: classNames('popover-header', className),
        children: children
    });
});
PopoverTitle.displayName = 'PopoverTitle';
export default PopoverTitle;
